<template lang="pug">
     .section.announce.green(
        :class='content.theme',
        v-observe-visibility='visibilityChanged'
        )
        .textwrapper
            .section-heading(
                v-if='content.title'
                )
                ArticleTitle(:title='content.title', color='color', :isActive='isActive')
</template>
<script>
export default {
    components: {
        ArticleTitle: () => import('../components/ArticleTitle.vue')
    },
    data() {
        return {
            isActive: false
        };
    },
    props: {
        theme: String,
        content: Object
    },
    methods: {
        setArticleText() {
            this.articleText = this.$store.getters.getArticle(this.articleId, this.sectionId, this.categoryId).footer.text;
        },
        visibilityChanged(isVisible) {
            if (isVisible) this.isActive = true;
            else this.isActive = false;
        }
    }
};
</script>
<style lang="scss">
@import '../assets/css/vars.scss';
.section.announce {
    padding-bottom: 20vh;
    background-color: var(--color-red);
}
</style>
